import { render, staticRenderFns } from "./BasketReassurance.vue?vue&type=template&id=db5e7374&"
import script from "./BasketReassurance.vue?vue&type=script&lang=js&"
export * from "./BasketReassurance.vue?vue&type=script&lang=js&"
import style0 from "./BasketReassurance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports